import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus, Layers, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Welcome() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const handle = user?.collector_handle || user?.username || "collector";

  return (
    <div className="bg-black min-h-screen flex items-center justify-center px-5 py-24 text-center relative overflow-hidden">
      <motion.div aria-hidden className="absolute inset-0"
        initial={{ opacity: 0.2 }} animate={{ opacity: [0.2, 0.45, 0.2] }} transition={{ duration: 6, repeat: Infinity }}
        style={{ background: "radial-gradient(55% 45% at 50% 40%, rgba(155,92,255,0.12), transparent 70%)" }} />
      <div className="relative z-10 max-w-xl">
        <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="font-tech text-[11px] tracking-[0.45em] text-[color:var(--chrome-3)]">WELCOME TO CARDSCIENCE<span className="text-holo">HQ</span></motion.p>

        <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.35 }}
          className="h-display text-4xl sm:text-5xl text-holo mt-6 leading-tight">LET&apos;S BUILD YOUR COLLECTION.</motion.h1>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.65 }}
          className="text-base text-[color:var(--chrome-2)] mt-5">
          Your private vault is ready, <span className="text-white">{handle}</span>. Add your first card to begin.
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.85 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button data-testid="welcome-add-first" onClick={() => navigate("/vault?add=1")}
            className="btn-holo inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm w-full sm:w-auto justify-center">
            <Plus size={18} /> ADD YOUR FIRST CARD
          </button>
          <button data-testid="welcome-start-collection" onClick={() => navigate("/vault")}
            className="btn-ghost inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm w-full sm:w-auto justify-center">
            <Layers size={18} /> START WITH YOUR COLLECTION <ArrowRight size={15} />
          </button>
        </motion.div>
      </div>
    </div>
  );
}
